import { decryptResponseAES, libEncrypAES } from 'utils/Encriptar/crypto';
import { v4 as uuidv4 } from 'uuid';
import { emp, enableGCM, plataforma1, urlBase, urlPhp8 } from '../constants/urls';
import { desencriptarTramaAES } from '../utils/Encriptar';
import { encriptarTramaAES } from '../utils/Encriptar/index';
import { getApikey } from './keys';
/**
 *
 * @param {string} url
 * @returns {string}
 */
const addRequestID = (url) => {
  const timestamp = new Date().getTime();
  const requestId = `${timestamp}-${uuidv4()}`;
  return `${url}&request_id=${requestId}`;
};

export const apiGet = async (url) => {
  try {
    return await fetch(addRequestID(url)).then((response) => response.json());
  } catch (error) {
    return { errorDescripcion: 'Error al Consultar', transaccion: false };
  }
};

export const apiPost = async (url, param, headers = {}) => {
  try {
    return await fetch(addRequestID(url), {
      method: 'post',
      headers: {
        Accept: 'application/json',
        ...headers,
      },
      body: JSON.stringify(param),
    }).then((response) => response.json());
  } catch (error) {
    return {
      errorDescripcion: 'Error al Consultar',
      transaccion: false,
      error,
    };
  }
};

// Funcion para encriptar datos

export const realizarEncriptacionAes = async (param) => {
  let dataEncriptar = JSON.stringify(param);
  let encrypted64Login = encriptarTramaAES(dataEncriptar);

  encrypted64Login = Buffer.from(JSON.stringify(encrypted64Login)).toString('base64');

  return {
    empresa: emp,
    plataforma: plataforma1,
    Data: encrypted64Login,
  };
};

export const realizarDesEncriptacionAes = async (data) => {
  if ((data.iv !== undefined) & (data.Data !== undefined) & (data.key !== undefined)) {
    data = desencriptarTramaAES(data.Data, data.key, data.iv);
  }
  return data;
};

export const consumirServicioEncirptacion = async (url, param) => {
  try {
    console.log('*************************************************************************');
    console.log('SERVICIO: ', url);
    console.log('BODY: ', param);
    param = await realizarEncriptacionAes(param);
    let resp = await apiPost(url, param);
    resp = await realizarDesEncriptacionAes(resp);
    console.log('RESPUESTA: ', resp);
    console.log('*************************************************************************');
    if (resp.transaccion === true) {
      return resp;
    } else {
      return {
        ...resp,
        errorDescripcion:
          resp?.errorDescripcion?.errorDescripcion ||
          resp?.errorDescripcion ||
          'Error al Consultar',
        transaccion: false,
      };
    }
  } catch (error) {
    return {
      ...error,
      errorDescripcion:
        error?.errorDescripcion?.errorDescripcion ||
        error?.errorDescripcion ||
        'Error al Consultar',
      transaccion: false,
    };
  }
};

/**
 *
 * @param {string} url
 * @param {any} param
 * @returns
 */
export const fetchPhpEigth = async (url, param) => {
  if (enableGCM) {
    return fetchGCM(url.replace(urlBase, urlPhp8), param);
  }
  return consumirServicioEncirptacion(url, param);
};

export const fetchGCM = async (url, param) => {
  try {
    param = await libEncrypAES(param);
    const headers = {
      'Accept-Encryption': 'gcm',
    };

    const respApi = await apiPost(url, param, headers);
    let resp = respApi;

    resp = decryptResponseAES(respApi);
    if (resp.transaccion === true) {
      return resp;
    } else {
      return {
        ...resp,
        errorDescripcion:
          resp?.errorDescripcion?.errorDescripcion ||
          resp?.errorDescripcion ||
          'Error al Consultar',
        transaccion: false,
      };
    }
  } catch (error) {
    return {
      ...error,
      errorDescripcion:
        error?.errorDescripcion?.errorDescripcion ||
        error?.errorDescripcion ||
        'Error al Consultar',
      transaccion: false,
    };
  }
};

export const fetchWithApiKey = async (url, body) => {
  try {
    const bodyEncriptado = await realizarEncriptacionAes(body);
    let resp = await apiPost(url, bodyEncriptado, { 'X-Api-Key': getApikey() });
    resp = await realizarDesEncriptacionAes(resp);
    if (resp.transaccion === true) {
      return resp;
    } else {
      return {
        ...resp,
        errorDescripcion:
          resp?.errorDescripcion?.errorDescripcion ||
          resp?.errorDescripcion ||
          'Error al Consultar',
        transaccion: false,
      };
    }
  } catch (error) {
    return {
      ...error,
      errorDescripcion:
        error?.errorDescripcion?.errorDescripcion ||
        error?.errorDescripcion ||
        'Error al Consultar',
      transaccion: false,
    };
  }
};
